import { gql } from '@apollo/client'

export const SHOP_ADDRESS_FRAGMENT = gql`
  fragment ShopAddress on ShopAddress {
    address
    cityGooglePlaceId
    city
    countryIsoCode
    id
    phone
    stateIsoCode
    zipCode
  }
`
